// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var generalCommonJS = require("../../js/generalCommon.js")
var stripeCommonJS = require("../../js/stripeCommon.js")

// CONFIGURACIÓN
const BillingPlans = (params) => {

  useEffect(() => {        
    stripeCommonJS.cargarPlanesStripe()
    console.log("Página de planes de pago cargada correctamente.")      
  }, [params.updateBillingPlans])

  function obtenerIdInstalacion(){

    var idInstalacion = ""

    if(localStorage.getItem("installationId") !== null){
      idInstalacion = localStorage.getItem("installationId")
    }
    else{
      idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
    }

    return idInstalacion
  }

  return (
    <>                
        <stripe-pricing-table 
          pricing-table-id="prctbl_1OxoW6DQQkhyuOWZ8xZeoCP5"
          publishable-key="pk_live_51Ow4bTDQQkhyuOWZbH63P9n83B6z1sIWZzkWNrIcuvcAYlbtFm79l4xiMMU68rSE3bIG0aXTKL2RUzraJ7IjQ2uY009iX8xhkq"
          customer-email={generalCommonJS.obtenerEmailUsuario()}          
          client-reference-id={localStorage.getItem("accountID")+"-"+obtenerIdInstalacion()} 
        >
        </stripe-pricing-table>   
    </>
  )
}

export default BillingPlans